import React, { useState, useEffect } from 'react';
import {
    Card,
    CardBody,
    Col,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';
import { useParams } from 'react-router-dom';
import { get } from '../../hook/request';
import { H1 } from '../../AbstractElements';
import { Progetto } from '../../Types/Panel.type'
import TabAttivita from './attivita';
import ProgettoAppuntiEditor from './appunti';
import FasiProgetto from './fasiProgetto';
import FavouriteButton from '../../Components/Widgets/Favourite'


export const tabActive = [
    { id: '1', nav: 'Gestione Attività', icon: '', text: 'Gestione Attività' },
    { id: '2', nav: 'Appunti Software', icon: '', text: 'Appunti Software' },
    { id: '3', nav: 'Fasi del progetto', icon: '', text: 'Fasi del Progetto' },
];

export default function TabProgetti() {
    const [basicTab, setBasicTab] = useState('1');
    const { id: progettoId } = useParams<{ id: string; }>();
    const [progetto, setProgetto] = useState<Progetto | null>(null);
    const [progettoLoading, setProgettoLoading] = useState(false);
    const [open, setOpen] = useState<string | string[]>('');
    const toggleAccordion = (id: string) => {
    setOpen(open === id ? '' : id);
};


    useEffect(() => {
        if (!progettoId) return;
        (async () => {
            try {
                setProgettoLoading(true);
                const res = await get<Progetto | { data?: Progetto }>(
                    `/progetti/detail?ID=${progettoId}`
                );
                const payload: any = (res as any)?.data.data ?? res;
                setProgetto(payload as Progetto);
            } catch (err) {
            } finally {
                setProgettoLoading(false);
            }
        })();
    }, [progettoId]);



    return (
        <div className="page-body pt-4">
            <Card>
                <CardBody>
                    <Col>
                        <div className="tabs-responsive-side">
                            <div className=" d-flex flex-column justify-content-start align-items-start">
                                {
                                    progetto?.nome &&
                                    (
                                        <div className='mb-4 px-3 d-flex justify-content-between w-100'>
                                            <div>
                                                <H1>
                                                    {progetto.nome}
                                                </H1>
                                            </div>
                                            <div>
                                                <FavouriteButton
                                                    percorso={'/progetti/' + progettoId}
                                                    nome={progetto.nome}
                                                />
                                            </div>
                                        </div>
                                    )
                                }

                                {progetto?.descrizione && (
                                    <div className="my-3 w-100">
                                        <Accordion open={open} toggle={toggleAccordion} className='dark-accordion'>
                                            <AccordionItem className="accordion-wrapper accordion-left-border">
                                                <AccordionHeader  color='light-primary' className="text-info" targetId="1">
                                                    Descrizione progetto
                                                        {open ? <i className="iconly-Arrow-Up-2 icli ms-auto icon font-primary" /> : <i className="iconly-Arrow-Down-2 icli ms-auto icon font-primary" />}
                                
                                                </AccordionHeader>

                                                <AccordionBody accordionId="1">
                                                    <div
                                                        dangerouslySetInnerHTML={{ __html: progetto.descrizione }}
                                                    />
                                                </AccordionBody>
                                            </AccordionItem>
                                        </Accordion>
                                
                                    </div>
                                )}




                                <div className="d-flex">
                                    <Nav className="border-tab border-0 mb-0 nav-danger" pills>
                                        {tabActive.map((item) => (
                                            <NavItem key={item.id}>
                                                <NavLink
                                                    href="#"
                                                    onClick={(e) => {
                                                        e.preventDefault();          // <--- evita il reload
                                                        setBasicTab(item.id);
                                                    }}
                                                    className={`nav-border text-danger nav-danger ${basicTab === item.id ? 'active' : ''
                                                        }`}
                                                >
                                                    <span className="d-inline-flex align-items-center gap-2">
                                                        {item.icon}
                                                        <span>{item.text}</span>
                                                    </span>
                                                </NavLink>
                                            </NavItem>
                                        ))}
                                    </Nav>
                                </div>

                                {/* CONTENUTO DEI TAB */}
                                <div className="material-content mt-3 w-100">
                                    <TabContent activeTab={basicTab}>
                                        <TabPane tabId="1">
                                            <TabAttivita />
                                        </TabPane>

                                        <TabPane tabId="2">
                                            <ProgettoAppuntiEditor />
                                        </TabPane>
                                        
                                        <TabPane tabId="3">
                                            <FasiProgetto />
                                        </TabPane>
                                    </TabContent>
                                </div>
                            </div>
                        </div>
                    </Col>
                </CardBody>
            </Card>
        </div>
    );
}
